import { useEffect, useState } from "react";

// use in combination with a useEffect hook to trigger a function *delay* seconds after the last update to *value*, returns the current value of *value*

// useEffect(() => {
//     doSomething(debouncedQuery);
// }, [debouncedQuery]);

export function useDebounce(value: string, delay: number) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};
